module.exports = __webpack_public_path__ + "859cfb6a695b728cdd39c90cc74984cf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons/lightbulb.png
// module id = 3698
// module chunks = 0